var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoParticipantscreener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H33L26 18L33 32H3L10 18L3 4Z",
    fill: "#B27DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoParticipantscreener);
export default __webpack_public_path__ + "static/media/Ico_Participant screener.defb7bb262aacf49899b96a0b881a6a5.svg";
export { ForwardRef as ReactComponent };